import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=2b3569ae&scoped=true&"
import script from "./task-detail.vue?vue&type=script&lang=js&"
export * from "./task-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=2b3569ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3569ae",
  null
  
)

export default component.exports